// @ts-nocheck
import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const DateTimeComponent = React.forwardRef((props, ref) => {
  const dateRef = ref || React.useRef();
  const { sx, ...otherProps } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        sx={{
          "&.MuiFormControl-root .MuiInputBase-root": {
            height: "32px",
            background: "white",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "var(--info-light-blue)",
            borderWidth: "1px",
          },
          ...sx,
        }}
        {...otherProps}
        defaultValue={otherProps.defaultValue ? dayjs(otherProps.defaultValue) : null}
        maxDate={otherProps.maxDate ? dayjs(otherProps.maxDate) : null}
        maxDateTime={otherProps.maxDateTime ? dayjs(otherProps.maxDate) : null}
        minDate={otherProps.minDate ? dayjs(otherProps.minDate) : null}
        minDateTime={otherProps.minDateTime ? dayjs(otherProps.minDate) : null}
        value={otherProps.value ? dayjs(otherProps.value) : null}
        ref={dateRef}
      />
    </LocalizationProvider>
  );
});
DateTimeComponent.displayName = "DateTimeComponent";
export default DateTimeComponent;
